import { Link } from "@tanstack/react-router";
import { MessageCircle } from "lucide-react";
import * as m from "~/paraglide/messages.js";

/**
 * The route to `/chat`, which neither the header nor the footer carries, shown
 * on every public page. `preload="intent"` warms the route on hover. It is
 * intentionally not mounted inside the `(chat)` layout, so it disappears once
 * you are on the chat page itself.
 *
 * Colour and size live in `styles/lindevo/chrome.css` (`.ask-launcher`), beside
 * the other fixed control on the site. That file also hides this control below
 * 720px, where the page goes full-bleed and a fixed corner control would sit on
 * top of the page's own buttons; the header's menu panel carries the link there
 * instead.
 *
 * The label is real text rather than an `aria-label` on an icon, so the link
 * names itself the same way to everyone.
 */
export function Chatbot() {
  return (
    <Link className="ask-launcher" preload="intent" to="/chat">
      <MessageCircle aria-hidden="true" size={17} strokeWidth={1.75} />
      <span className="ask-launcher-label">{m.chatbot_launcher_label()}</span>
    </Link>
  );
}
